exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/widget/kitting-detail-table-widget/kitting-detail-table-widget.component.css
// module id = ../../../../../src/app/shared/components/widget/kitting-detail-table-widget/kitting-detail-table-widget.component.css
// module chunks = main